export default __webpack_public_path__ + "static/media/google.3d2baa2c.svg";